jQuery(function ($) {

    // Enable/disable state depending on country
    $('input[data-country-field]').each(function () {

        var $state = $(this);
        var countries_with_states = $state.data('country-ids');
        var country_field_id = $state.data('country-field');
        var $country = $('#' + country_field_id);

        if ($country.length === 0) {
            console.warn("Cannot find field #" + country_field_id, this);
            return;
        }

        function toggle_state_field() {
            var country_id = $country.val();

            if (!country_id || countries_with_states.indexOf(country_id) > -1) {
                $state.prop('disabled', false);
            } else {
                $state.prop('disabled', true);
            }
        }

        $country.change(toggle_state_field);
        toggle_state_field();
    });
});
